/**
 * Shared constants for the Forms feature.
 * Used by both agent-facing and admin-facing components.
 */

/**
 * Status badge Tailwind classes keyed by order/item status name.
 */
export const ORDER_STATUS_COLORS = {
  'New': 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  'Processing': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  'Shipped': 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  'Canceled': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  'Cancelled': 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  'Received': 'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
  'Voided': 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
};

/** Fallback color when status is unknown. */
export const DEFAULT_STATUS_COLOR = 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';

/**
 * Reusable StatusPill component for rendering order/item status badges.
 */
export const StatusPill = ({ status }) => {
  const colorClass = ORDER_STATUS_COLORS[status] || DEFAULT_STATUS_COLOR;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${colorClass}`}>
      {status}
    </span>
  );
};
